export const STUDENT_STATUS = {
  verify_email: { label: "Verify email first", tone: "bg-amber-50 text-amber-800 border-amber-200" },
  consent_required: { label: "Consent required", tone: "bg-rose-50 text-rose-700 border-rose-200" },
  payment_required: { label: "Payment required", tone: "bg-amber-50 text-amber-800 border-amber-200" },
  consent_verification_pending: { label: "Consent verification pending", tone: "bg-blue-50 text-blue-700 border-blue-200" },
  paid_not_started: { label: "Paid - ready to start", tone: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  in_progress: { label: "In progress", tone: "bg-blue-50 text-blue-700 border-blue-200" },
  report_generating: { label: "Report generating", tone: "bg-blue-50 text-blue-700 border-blue-200" },
  retake_not_available: { label: "Report available", tone: "bg-[#F3E8F1] text-[#4F0341] border-[#E9DFE7]" },
  report_available: { label: "Report available", tone: "bg-[#F3E8F1] text-[#4F0341] border-[#E9DFE7]" },
};

export const PAYMENT_STATE = {
  PAYMENT_INITIATED: { label: "Initiated", tone: "bg-blue-50 text-blue-700 border-blue-200" },
  PAYMENT_SUCCESS: { label: "Paid", tone: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  PAYMENT_FAILED: { label: "Failed", tone: "bg-rose-50 text-rose-700 border-rose-200" },
  PAYMENT_CANCELLED: { label: "Cancelled", tone: "bg-slate-100 text-slate-600 border-slate-200" },
  PAYMENT_REFUNDED: { label: "Refunded", tone: "bg-amber-50 text-amber-800 border-amber-200" },
};

export const CONSENT_STATUS = {
  esign_recorded: { label: "E-signed (awaiting payment verification)", tone: "bg-blue-50 text-blue-700 border-blue-200" },
  verified_payment: { label: "Verified via payment", tone: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  verified_offline_form: { label: "Verified (signed form)", tone: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  verified_admin: { label: "Verified by admin", tone: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  verified_reconsent: { label: "Verified (re-consent)", tone: "bg-emerald-50 text-emerald-700 border-emerald-200" },
};

export const CLASSES = [7, 8, 9, 10, 11, 12];

export function Pill({ map, value, testId }) {
  const item = map[value] || { label: value || "-", tone: "bg-slate-100 text-slate-600 border-slate-200" };
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${item.tone}`}>
      {item.label}
    </span>
  );
}
